/**
 * MobileSectionNav — the <lg transformation of the persistent left nav.
 * A professional compact section navigator: sticky horizontal index with a
 * leading "On this page" caption, PRIMARY SANS labels, and an underline active
 * indicator. NOT the old rounded-pill mono chip strip (rejected as cheap).
 *
 * Props:
 *   items     – flat [{ id, num?, label }]  (caller flattens hierarchical groups)
 *   activeId  – current section id (scroll-spy)
 *   label     – accessible name
 */
export function MobileSectionNav({ items, activeId, label = "On this page" }) {
  return (
    <nav
      aria-label={label}
      className="lg:hidden sticky top-16 z-30 border-b border-memo-line"
      style={{ backgroundColor: "rgba(246,244,238,0.96)" }}
    >
      <div className="flex items-stretch gap-4 px-4">
        <span className="font-mono text-[0.62rem] uppercase tracking-[0.2em] text-memo-muted flex items-center shrink-0">
          {label}
        </span>
        <ul className="flex gap-1 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden">
          {items.map((item) => {
            const isActive = item.id === activeId;
            return (
              <li key={item.id} className="shrink-0">
                <a
                  href={`#${item.id}`}
                  aria-current={isActive ? "true" : undefined}
                  className={`inline-flex items-baseline gap-1.5 min-h-[44px] px-2.5 text-[0.85rem] whitespace-nowrap border-b-2 transition-colors duration-150 ${
                    isActive
                      ? "border-memo-signal text-memo-ink"
                      : "border-transparent text-memo-muted hover:text-memo-ink-2"
                  }`}
                >
                  {item.num ? (
                    <span className="font-mono text-[0.66rem] text-memo-signal tabular-nums">{item.num}</span>
                  ) : null}
                  <span className="font-body">{item.label}</span>
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
}
